










import mixins from 'vue-typed-mixins';
import { SurveyGroup } from '@/utils/SurveyUtils';
import DashboardCanvasVue from '@/components/dashboard/DashboardCanvas.vue';
export default mixins().extend({
  components: {
    DashboardCanvas: DashboardCanvasVue,
  },
  props: {
    value: {
      type: Object as () => SurveyGroup,
    },
    pristine: {
      type: Object as () => SurveyGroup,
    },
  },

  methods: {
    submit() {
      this.$emit('submit', this.value);
    },
  },
});
